import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProfilePage } from '@/features/social/profile-page';
import { isProfileTab, type ProfileTab } from '@/features/social/profile-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Profil de l'utilisateur courant (volet social) : « Mon fil » et « Abonnements », ouverts par le menu
 * utilisateur. L'onglet vit dans l'URL (`?tab=following`) ; le premier ne l'écrit pas.
 */
export const Route = createFileRoute('/$tenant/me')({
  validateSearch: (search: Record<string, unknown>): { tab?: ProfileTab } =>
    isProfileTab(search['tab']) && search['tab'] !== 'feed' ? { tab: search['tab'] } : {},
  component: ProfileRoute,
});

function ProfileRoute() {
  const { tenant } = Route.useParams();
  const { tab = 'feed' } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} crumbs={[{ label: t('topbar.profile') }]}>
      <ProfilePage
        tenantId={tenant}
        tab={tab}
        onTabChange={(next) => void navigate({ search: next === 'feed' ? {} : { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
